var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36 3.875c1.027 0 1.86-.84 1.86-1.875A1.868 1.868 0 002.36.125C1.333.125.5.965.5 2c0 1.036.833 1.875 1.86 1.875zM3.875 5.375h-3A.375.375 0 00.5 5.75v9.75c0 .207.168.375.375.375h3a.375.375 0 00.375-.375V5.75a.375.375 0 00-.375-.375zM15.125 15.875h-2.25a.375.375 0 01-.375-.375V9.875a1.875 1.875 0 00-3.75 0V15.5a.375.375 0 01-.375.375h-2.25a.375.375 0 01-.375-.375V5.75a.375.375 0 01.375-.375h2.25a.375.375 0 01.375.375.308.308 0 00.54.203A3.158 3.158 0 0111.668 5C13.903 5 15.5 6.373 15.5 9.2v6.3a.375.375 0 01-.375.375z"
  })));
}

export default SvgLinkedininline;